import request from '@/utils/request'

// 查询韩国SPS通报列表
export function listSpsReport(query) {
  return request({
    url: '/web/zlts/bzfw/hgSpsReport/list',
    method: 'get',
    params: query
  })
}